"use client";

import { c as _c } from "react/compiler-runtime";
import type React from "react";
import { LocalWalletBadge } from "@/components/auth/login/local-wallet-badge";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { getPasswordSubtitle, getUnlockButtonLabel } from "@/lib/auth/login-copy";
import type { LocalWalletIdentity } from "@/lib/local-wallet-identity";
export function UnlockContent(t0) {
  const $ = _c(41);
  const {
    loading,
    localWallet,
    oauthClient,
    onClearBackup,
    onPasswordChange,
    onSubmit,
    password,
    unregisteredKey: t1,
    creatingAccount: t2,
    onCreateAccountWithKey
  } = t0;
  const unregisteredKey = t1 === undefined ? false : t1;
  const creatingAccount = t2 === undefined ? false : t2;
  const t3 = oauthClient ? "Sign in to continue" : "Unlock Your ID";
  let t4;
  if ($[0] !== t3) {
    t4 = <h2 className="font-bold text-xl">{t3}</h2>;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== oauthClient) {
    t5 = getPasswordSubtitle(oauthClient);
    $[2] = oauthClient;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t5) {
    t6 = <p className="text-muted-foreground text-sm">{t5}</p>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t4 || $[7] !== t6) {
    t7 = <div className="flex flex-col items-center gap-2 text-center">{t4}{t6}</div>;
    $[6] = t4;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== localWallet) {
    t8 = localWallet ? <LocalWalletBadge wallet={localWallet} /> : null;
    $[9] = localWallet;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== creatingAccount || $[12] !== loading || $[13] !== onCreateAccountWithKey || $[14] !== unregisteredKey) {
    t9 = unregisteredKey && onCreateAccountWithKey ? <div className="space-y-3 rounded-lg border border-primary/30 bg-primary/5 p-4 text-center" role="status"><p className="font-medium text-sm">This key isn't registered with Sigma yet.</p><p className="text-muted-foreground text-xs">Your key is your account. Create one now and everything else stays optional.</p><Button className="w-full" disabled={creatingAccount || loading} onClick={onCreateAccountWithKey} type="button">{creatingAccount ? "Creating..." : "Create a Sigma account with this key"}</Button></div> : null;
    $[11] = creatingAccount;
    $[12] = loading;
    $[13] = onCreateAccountWithKey;
    $[14] = unregisteredKey;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Label htmlFor="password">Password</Label>;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== onPasswordChange) {
    t11 = e => onPasswordChange(e.target.value);
    $[17] = onPasswordChange;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== loading || $[20] !== password || $[21] !== t11) {
    t12 = <div className="grid gap-2">{t10}<Input autoFocus={true} disabled={loading} id="password" onChange={t11} placeholder="Enter your backup password" required={true} type="password" value={password} /></div>;
    $[19] = loading;
    $[20] = password;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = loading || !password;
  let t14;
  if ($[23] !== loading || $[24] !== oauthClient) {
    t14 = getUnlockButtonLabel(loading, oauthClient);
    $[23] = loading;
    $[24] = oauthClient;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t13 || $[27] !== t14) {
    t15 = <Button className="w-full" disabled={t13} type="submit">{t14}</Button>;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== onClearBackup) {
    t16 = <div className="text-center"><Button className="text-sm" onClick={onClearBackup} type="button" variant="link">Not you? Switch accounts</Button></div>;
    $[29] = onClearBackup;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== onSubmit || $[32] !== t12 || $[33] !== t15 || $[34] !== t16) {
    t17 = <form className="flex flex-col gap-6" data-login-form={true} onSubmit={onSubmit}>{t12}{t15}{t16}</form>;
    $[31] = onSubmit;
    $[32] = t12;
    $[33] = t15;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t17 || $[37] !== t7 || $[38] !== t8 || $[39] !== t9) {
    t18 = <>{t7}{t8}{t9}{t17}</>;
    $[36] = t17;
    $[37] = t7;
    $[38] = t8;
    $[39] = t9;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  return t18;
}